var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.7071 3.29289L20.7071 7.29289C21.0976 7.68342 21.0976 8.31658 20.7071 8.70711L9.70711 19.7071C9.56751 19.8467 9.38971 19.9419 9.19612 19.9806L4.19612 20.9806C3.4964 21.1205 2.87948 20.5036 3.01943 19.8039L4.01943 14.8039C4.05814 14.6103 4.1533 14.4325 4.2929 14.2929L15.2929 3.29289C15.6834 2.90237 16.3166 2.90237 16.7071 3.29289ZM13.4995 7.914L5.92121 15.493L5.27476 18.7252L8.50699 18.0788L16.0855 10.5L13.4995 7.914ZM16 5.41421L14.9145 6.5L17.4994 9.085L18.5858 8L16 5.41421Z",
  fill: "#3F7F7D"
})));
export { SvgEdit as ReactComponent };
export default __webpack_public_path__ + "assets/e4067397.svg";